import 'babel-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import {
  combineReducers,
  createStore,
  compose,
  applyMiddleware,
} from 'redux';
import thunk from 'redux-thunk';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import ReactGA from 'react-ga';
import createHistory from 'history/createBrowserHistory';

import CssBaseline from '@material-ui/core/CssBaseline';

import { MuiThemeProvider } from '@material-ui/core/styles';
import registerServiceWorker from './registerServiceWorker';

import './css/getCSS';
import App from './App';
import authReducer from './auth/reducers';
import commonReducer from './common/reducers';
import profileReducer from './profile/reducers';
import dashboardReducer from './dashboard/reducers';
import activitiesReducer from './activities/reducers';
import searchReducer from './search/reducers';
import mainReducer from './main/reducers';
import { getTheme, detectIE } from './util';

const composeEnhancers = process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : null || compose;


const rootReducer = combineReducers({
  auth: authReducer,
  common: commonReducer,
  profile: profileReducer,
  dashboard: dashboardReducer,
  activities: activitiesReducer,
  search: searchReducer,
  main: mainReducer,
});

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk)),
);

const theme = getTheme();

const history = createHistory();
ReactGA.initialize('UA-131668888-1');
history.listen((location, action) => {  // eslint-disable-line
  ReactGA.set({ page: location.pathname });
  ReactGA.pageview(location.pathname + location.search);
});


let app = (
  <Provider store={store}>
    <Router history={history}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </MuiThemeProvider>
    </Router>
  </Provider>
);

const version = detectIE();
if (version && version < 9) {
  app = (
    <h1 style={{ textAlign: 'center' }}>
      You are viewing the website on an old browser. <br />
      Please use a modern browser like Google Chrome,
      Firefox or Edge to get the best experience of the website.
    </h1>
  );
}

ReactDOM.render(app, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js